import React,{useContext} from "react";
import { XIcon } from "@heroicons/react/solid";
import axios from "axios";
import useState from "react-usestateref";
import backendService from "../services.js/backendService";
import { PuffLoader } from "react-spinners";
import CodeMirror from "@uiw/react-codemirror";
import { toast } from "react-toastify";
import { SocketContext } from "../services.js/socket";
// import "codemirror/theme/monokai.css";
// import "codemirror/mode/javascript/javascript";
// import "codemirror/addon/display/placeholder";


function EditCodeModal({ openEditCodeModal, codeData, getEditMessage }) {
  const [code, setCode, codeRef] = useState(codeData.content);
  const socket = useContext(SocketContext);
  const [loading, setLoading] = React.useState(false);
  const editCode = async () => {
    setLoading(true);
    const data = {
      content: codeRef.current,
    };
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_URL}/updatemessage/${codeData._id}`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": backendService.getToken(),
          },
        }
      );
      
      getEditMessage(response.data);
      socket.emit("editCode", { message: response.data, messageID: codeData._id });
      toast.success("Code updated successfully");
      setLoading(false);
      openEditCodeModal(false);
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="w-11/12 sm:w-5/6 md:w-3/4 lg:w-2/3 relative my-6 shadow-md shadow-black mx-auto max-w-4xl rounded-md">
          {/*content*/}
          <div className="border-0 rounded-lg  relative flex flex-col w-full  outline-none focus:outline-none">
            {/*header*/}
            <div className="flex items-start justify-between p-5  rounded-t bg-background">
              {loading ? (
                // <BallTriangle stroke="#000000" height={"1.5em"} />
                <div className="flex w-fitems-center justify-center text-primary">
                  <PuffLoader size={30} color={"#000"} loading={loading} />
                  <h3 className="text-xl font-robo text-primary ">
                    Updating ...
                  </h3>
                </div>
              ) : (
                <h3 className="text-xl font-robo text-primary ">
                  Edit Code Snippet
                </h3>
              )}
              <div className="h-7 w-7 flex items-center justify-center cursor-pointer hover:bg-palette_color1 hover:text-palette_color2 text-palette_color1 hover:rounded-full">
                <XIcon
                  className="h-5 w-5 "
                  aria-hidden="true"
                  onClick={() => openEditCodeModal(false)}
                />
              </div>
            </div>
            {/*body*/}
            <div className="relative px-6 flex-auto bg-background">
              <form action="#" method="POST">
                <div className="col-span-6 sm:col-span-3">
                  <div className="w-[100%]">
                    {/* <label className="block text-md font-medium pb-1 text-header_text tracking-widest">
                    Write code here
                    <span className="text-red-600"> *</span>
                  </label> */}
                    <textarea
                      id="codeTextArea"
                      name="codeTextArea"
                      value={codeRef.current}
                      onChange={(e) => setCode(e.target.value)}
                      className="appearance-none rounded relative block w-full px-3 py-2 border-[1px] border-palette_color1 bg-palette_color2 placeholder-secondary text-primary rounded-t-md focus:outline-none focus:z-10 sm:text-sm my-1"
                      rows={18}
                    />
                    {/* <CodeMirror
                    value={codeRef.current}
                    options={{
                      placeholder: "Please enter the JavaScript code.",
                      tabSize: 4,
                      mode: "jsx",
                    }}
                  /> */}
                  </div>
                </div>
              </form>
            </div>
            {/*footer*/}
            <div className="flex items-center justify-end p-3 pt-3 pr-6  rounded-b bg-background">
              <button
                className="bg-palette_color1 border-[1px] border-palette_color1 mt-1 hover:bg-palette_color2 text-white hover:text-palette_color1  font-robo uppercase text-md  px-8 py-1 rounded shadow-sm hover:border hover:border-palette_color1  ease-linear transition-all duration-500"
                type="button"
                disabled={loading}
                onClick={async () => await editCode()}
              >
                Edit
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-50  fixed inset-0 z-20 bg-black"></div>
    </>
  );
}

export default EditCodeModal;
